import HeroSection from '../components/heroSection';
import TeamsSection from '../components/TeamsSection';

const Teams = () => (
  <div className="teams">
    <HeroSection />
    <TeamsSection />
  </div>
);

export default Teams;
